export const boxModalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "60%",
  // bgcolor: "background.paper",
  borderRadius: 3,
  boxShadow: 24,
  p: 2,
};

export const circularProgressStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  marginTop: "-12px",
  marginLeft: "-12px",
};

export const suggestionBackgroundColor = (color) => {
  return {
    backgroundColor: color,
    cursor: "pointer",
  };
};

export const displayBox = (select, optionA, optionB) => {
  return {
    display: {
      xs: select === optionA || select === optionB ? "block" : "none",
      md: select === optionA || select === optionB ? "block" : "none",
    },
  };
};